import styled from 'styled-components';

const StyledAppFooter = styled.div`
    color: inherit;
`;

export default StyledAppFooter;
